import type { IconNode } from '../types';

/**
 * @name tab-x
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTQuNSA5LjUtNSA1IiAvPgogIDxwYXRoIGQ9Im0xNC41IDE0LjUtNS01IiAvPgogIDxwYXRoIGQ9Ik00IDIwVjZhMiAyIDAgMCAxIDItMmgxMmEyIDIgMCAwIDEgMiAydjE0IiAvPgogIDxwYXRoIGQ9Ik0yMiAyMEgyIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/tab-x
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const tabX: IconNode = [
  ['path', { d: 'm14.5 9.5-5 5', key: '17q4r4' }],
  ['path', { d: 'm14.5 14.5-5-5', key: '6c99jr' }],
  ['path', { d: 'M4 20V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v14', key: 'y8tqhg' }],
  ['path', { d: 'M22 20H2', key: '1p1f7z' }],
];

export default tabX;
